import { epics as errorHandlingEpics } from './errorHandling';

export const globalEpics = [errorHandlingEpics];
